import React, { useCallback, useMemo } from 'react'
import {
  GoToURLAction,
  AnyActionType,
  IActionComponentProps,
} from '~core/forge.type'
import useDispatch from '~editor/hooks/useDispatch'
import { Button, InputGroup, Input, InputLeftAddon } from '@chakra-ui/react'
import { Box } from '@chakra-ui/react'

interface IProps extends IActionComponentProps {
  action: GoToURLAction
}

export const GoToURLActionComponent = ({
  action,
  actions,
  activeActionGesture,
}: IProps) => {
  const dispatch = useDispatch()
  const isInvalid = useMemo(() => {
    return !/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_\+.~#?&\/\/=]*)/.test(
      action.url,
    )
  }, [action.url])

  const updateURL = useCallback(
    (url: string) => {
      const cleanURL = url.replace(/^https?:\/\//, '')

      dispatch.nodes.updateActions({
        actionGestureType: activeActionGesture,
        actions: actions.map((_a: AnyActionType) => {
          const _action = { ..._a } as GoToURLAction

          if (action.id === _action.id) {
            _action.url = cleanURL
          }

          return _action
        }),
      })
    },
    [dispatch, activeActionGesture, actions],
  )

  return (
    <Box width="100%" display="flex" alignItems="center">
      <InputGroup>
        <InputLeftAddon height="32px">{'https://'}</InputLeftAddon>
        <Input
          width="100%"
          height="32px"
          value={action.url}
          placeholder="URL"
          isInvalid={isInvalid}
          onChange={(e) => {
            const url = e.target.value

            updateURL(url)
          }}
        />
      </InputGroup>
      <Button
        variant="warningGhost"
        fontSize="12px"
        onClick={() => {
          updateURL('')
        }}
      >
        {'Clear'}
      </Button>
    </Box>
  )
}

export default GoToURLActionComponent
